import React, { useState, useEffect } from "react";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import HomeSharpIcon from "@mui/icons-material/HomeSharp";
import ShoppingCartSharpIcon from "@mui/icons-material/ShoppingCartSharp";
import Badge from "@mui/material/Badge";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { decodeUrl, encodeUrl } from "../../utils/common/UrlUtils";

export default function GuestBottomNavigation() {
  // Hooks start
  const navigate = useNavigate();
  const location = useLocation();

  // Redux state
  const cartItems = useSelector((state) => state.guestCart.items);
  const guestDecoded = useSelector((state) => state.guestDecoded);
  // Hooks end

  // Handlers start
  // Calculate total items
  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  // Extract query parameters from Redux state or fallback to empty values
  const [queryParams, setQueryParams] = useState({
    compcode: "",
    loccode: "",
    restcode: "",
    tablecode: "",
  });

  useEffect(() => {
    if (guestDecoded) {
      setQueryParams({
        compcode: guestDecoded.COMPCODE || "",
        loccode: guestDecoded.LOCCODE || "",
        restcode: guestDecoded.RESTCODE || "",
        tablecode: guestDecoded.TABLECODE || "",
      });
    }
  }, [guestDecoded]);

  // Determine the current active tab based on the URL
  const getActiveTab = () => {
    if (location.pathname.startsWith("/GuestCheckout")) {
      return 1;
    }
    return 0; // Default to "Home"
  };

  const handleNavigationChange = (event, newValue) => {
    // Encode query parameters before navigating
    const encodedParams = new URLSearchParams({
      compcode: encodeUrl(queryParams.compcode),
      loccode: encodeUrl(queryParams.loccode),
      restcode: encodeUrl(queryParams.restcode),
      tablecode: encodeUrl(queryParams.tablecode),
    }).toString();

    if (newValue === 0) {
      navigate(`/Guest?${encodedParams}`);
    } else if (newValue === 1) {
      navigate(`/GuestCheckout?${encodedParams}`);
    }
  };
  // Handlers end

  return (
    <Paper
      sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
      elevation={3}
    >
      <BottomNavigation
        value={getActiveTab()} // Dynamically set the active tab based on the URL
        onChange={handleNavigationChange}
      >
        <BottomNavigationAction label="Home" icon={<HomeSharpIcon />} />
        <BottomNavigationAction
          label="Checkout"
          icon={
            <Badge badgeContent={totalItems} color="primary">
              <ShoppingCartSharpIcon />
            </Badge>
          }
        />
      </BottomNavigation>
    </Paper>
  );
}
